module.exports = __webpack_public_path__ + "static/media/chat-blip.981845a5.svg";